module.exports = __webpack_public_path__ + "79979ea63ee10a0589273d460a18cc1b.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/search_24.svg
// module id = 1776
// module chunks = 18 27 30